import type { NeverFunc } from "@suse-o11y/never-func";
import { unpurry } from "@suse-o11y/unpurry";
import { isDeepEqual as isDeepEqual_ } from "remeda";

export const isDeepEqual = unpurry(isDeepEqual_, 2) as typeof isDeepEqual_ & NeverFunc;
